import { createKeyedQueue } from '@/lib/serialQueue'
import { withCrossTabLock } from '@/lib/crossTabLock'

/**
 * App-wide write serialisation for idb-keyval map stores, keyed by storage key.
 *
 * idb-keyval mutations are read-modify-write (`load map → mutate → save map`).
 * Concurrent writers to the same key — the chat agent's `save_memory`, the
 * background memory pass, and UI edits all firing at once — would otherwise
 * interleave their load/save and clobber each other. Funnelling every write for
 * a key through one serial queue makes each mutation an atomic critical section
 * while unrelated stores stay concurrent.
 */
const withProcessLock = createKeyedQueue()

export const withStoreLock = <T>(
  key: string,
  task: () => Promise<T>,
): Promise<T> =>
  withProcessLock(key, () =>
    withCrossTabLock(`npi2:store:${key}`, task),
  )
